<template>
  <component
    v-if="appInitialized"
    :is="resolveLayoutVariant"
    :class="`skin-variant--${appSkinVariant}`"
  >
    <transition :name="appRouteTransition" mode="out-in" appear>
      <router-view></router-view>
    </transition>
  </component>
  <div v-else class="initializing">
    <v-progress-circular
      :size="70"
      :width="7"
      indeterminate
    ></v-progress-circular>
  </div>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import { computed } from "@vue/composition-api";
// eslint-disable-next-line import/no-unresolved
import useAppConfig from "@core/@app-config/useAppConfig";
import { useRouter } from "@core/utils";
import { useLayout } from "@core/layouts/composable/useLayout";

// Layouts
import LayoutContentVerticalNav from "@/layouts/variants/content/vertical-nav/LayoutContentVerticalNav.vue";
import LayoutContentHorizontalNav from "@/layouts/variants/content/horizontal-nav/LayoutContentHorizontalNav.vue";
import LayoutBlank from "@/layouts/variants/blank/LayoutBlank.vue";

// Dynamic vh
import useDynamicVh from "@core/utils/useDynamicVh";
import useAuth from "./useAuth";

export default {
  components: {
    LayoutContentVerticalNav,
    LayoutContentHorizontalNav,
    LayoutBlank,
  },
  setup() {
    const { appInitialized } = useAuth();
    const { route } = useRouter();
    const { appContentLayoutNav, appSkinVariant, appRouteTransition } =
      useAppConfig();

    const { handleBreakpointLayoutSwitch } = useLayout();
    handleBreakpointLayoutSwitch();

    const resolveLayoutVariant = computed(() => {
      if (route.value.meta.layout === "blank") return "layout-blank";

      if (route.value.meta.layout === "admin")
        return `layout-content-vertical-nav`;

      if (route.value.meta.layout === "default")
        return `layout-content-horizontal-nav`;

      if (route.value.meta.layout === "content")
        return `layout-content-${appContentLayoutNav.value}-nav`;

      return null;
    });

    useDynamicVh();

    return {
      resolveLayoutVariant,
      appSkinVariant,
      appRouteTransition,
      appInitialized,
    };
  },
};
</script>
<style lang="css">
.v-data-footer__select {
  display: none;
}
.initializing {
  margin-top: 40vh;
  text-align: center;
}
.v-progress-circular {
  color: #9f1f63;
}
.ql-editor p {
  margin-bottom: 16px !important;
}
</style>
